/* eslint-disable */
export default {
    profile_highest_advanced_education_level: "Wat is je hoogst genoten opleidingsniveau in het hoger- of beroepsonderwijs?",
    profile_highest_basic_education_level: "Wat is je hoogst genoten opleidingsniveau in het voortgezet onderwijs?",
    profile_date_of_birth: "Geboortedatum",
    profile_gender: "Geslacht",
    profile_unexpected_error: "Er is een fout opgetreden. Probeer het opnieuw.",
    profile_check_your_details_intro: "Controleer je gegevens en wijzig deze indien nodig",
    profile_check_your_details_title: "Je persoonlijke gegevens",
    profile_check_your_details_save: "Opslaan & doorgaan",
    profile_update_personal_data_error: "Er is een fout opgetreden bij het bijwerken van de persoonlijke gegevens. Probeer het later opnieuw.",
    profile_update_details_could_not_fetch_form_fields: "Er ging iets mis bij het ophalen van het formulier met id:",
    profile_feature_toggles_page_title: "Feature toggles",
    profile_update_details_success: "Het profiel is succesvol bijgewerkt",
    profile_cv_section_modal_title: "Verwijder bestand",
    profile_cv_section_modal_body: "Weet je zeker dat je dit bestand wilt verwijderen?",
    profile_cv_section_modal_cancel: "Annuleren",
    profile_cv_section_modal_confirm: "Verwijderen",
    profile_cv_section_title: "Upload CV",
    profile_cv_section_body: "Wij verzoeken je jouw CV te uploaden. Het CV zal gebruikt worden als input voor het gesprek met je adviseur van LTP, indien dit voor jou van toepassing is.",
    profile_education_title: "Opleiding",
    profile_cv_section_delete_error: "Er is iets misgegaan bij het verwijderen van het bestand. probeer het later opnieuw.",
    profile_cv_section_delete_success: "Het bestand is succesvol verwijderd.",
    profile_cv_section_upload_error: "Kon het bestand niet uploaden, probeer het later nog eens.",
    profile_cv_section_download_error: "Kon het bestand niet downloaden, probeer het later nog eens.",
    profile_general_error: "Er is iets misgegaan. Probeer het later opnieuw.",
    profile_update_details_failed: "Er ging iets mis bij het opslaan van de gegevens.",
    profile_cv_section_upload_too_large: "Het bestand is groter dan het toegestane maximum van 5Mb.",
    profile_date_of_birth_question: "Wat is je geboortedatum?",
    profile_amend_details_submit_button: "Naar programma",
    profile_date_of_birth_invalid_format: "Het formaat moet DD-MM-JJJJ zijn",
    profile_education_level_option_none: "None",
    profile_education_level_option_primary_education: "Primary education",
    profile_education_level_option_high_school: "High school",
    profile_education_level_option_vocational: "Vocational school",
    profile_education_level_option_college: "College",
    profile_education_level_option_university: "University",
    profile_education_level_option_phd: "PhD",
    profile_education_level_option_geen: "Geen",
    profile_education_level_option_havo: "Havo",
    profile_education_level_option_mavo_vmbo: "Mavo/vmbo",
    profile_education_level_option_praktijkonderwijs: "Praktijkonderwijs",
    profile_education_level_option_vwo: "Vwo",
    profile_education_level_option_hbo: "HBO",
    profile_education_level_option_mbo1: "MBO 1",
    profile_education_level_option_mbo2: "MBO 2",
    profile_education_level_option_mbo3: "MBO 3",
    profile_education_level_option_mbo4: "MBO 4",
    profile_education_level_option_bachelor: "WO bachelor",
    profile_education_level_option_master: "WO master",
    profile_select_active_competencies_label: "Welke competenties zou je willen meten? (min. 1)",
    profile_education_level_option_other: "Overig",
    profile_language_fluency_level: "Geef aan hoe goed je taalbeheersing is voor het",
    profile_language_fluency_level_primary: "Moedertaal / tweetalig",
    profile_language_fluency_level_full_professional: "Vloeiend",
    profile_language_fluency_level_professional_working: "Goede kennis",
    profile_language_fluency_level_limited_working: "Beperkte kennis",
    profile_language_fluency_level_elementary: "Basiskennis",
    profile_Language_fluency_level_limited_proficiency: "Beperkte kennis",
    profile_Language_fluency_level_proficient: "Goede kennis",
    profile_Language_fluency_level_fluent: "Vloeiend",
    profile_Language_fluency_level_secondary: "Twee- of meertalig met Nederlands als tweede taal",
    profile_Language_fluency_level_native: "Moedertaal, Nederlands is de eerste taal",
    profile_amend_details_submit_without_cv_button: "Doorgaan zonder CV"
};
